import { powerbiApiSlice } from "../apiSlice";


// Our Power BI endpoints to create workspace on Power BI Service data.

export const powerbiBaseApiSlice = powerbiApiSlice.injectEndpoints({
    endpoints: builder => ({
        getReportsInWorkspace: builder.query({
            query: (args) => {
                const { accountId } = args
                return {
                    url: `/Report?accountId=${accountId}`
                }
            },
            providesTags: ['Reports'],
        }),
        postDatasetRefreshRequest: builder.mutation({
            query: (args) => {
                const { datasetId } = args
                return {
                    url: `/dataset/refresh?datasetId=${datasetId}`,
                    method: 'POST'
                }
            }
        }),
        getDatasetRefreshStatus: builder.query({
            query: (args) => {
                const { datasetId } = args
                return {
                    url: `/dataset/refreshStatus?datasetId=${datasetId}`,
                }
            }
        }),
    })
});

export const {
    useGetReportsInWorkspaceQuery,
    usePostDatasetRefreshRequestMutation,
    useGetDatasetRefreshStatusQuery,
} = powerbiApiSlice